import logger from '@/logger';

const log = logger.getChild('csv-upload-generate-download-blob');

// hard to unit test but works as expected
export const downloadBlob = (
  content: BlobPart,
  filename: string,
  contentType: string,
): void => {
  log.log('Generating CSV template blob:', filename);
  const blob = new Blob([content], { type: contentType });
  const url = URL.createObjectURL(blob);

  const pom = document.createElement('a');
  pom.href = url;
  pom.setAttribute('download', filename);
  pom.click();
  log.log('Downloading CSV template file:', filename);
  URL.revokeObjectURL(pom.href);
  pom.remove();
};
